import { render, staticRenderFns } from "./AIOverview.vue?vue&type=template&id=730c64a6&scoped=true"
import script from "./AIOverview.vue?vue&type=script&lang=js"
export * from "./AIOverview.vue?vue&type=script&lang=js"
import style0 from "./AIOverview.vue?vue&type=style&index=0&id=730c64a6&lang=scss"
import style1 from "./AIOverview.vue?vue&type=style&index=1&id=730c64a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730c64a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('730c64a6')) {
      api.createRecord('730c64a6', component.options)
    } else {
      api.reload('730c64a6', component.options)
    }
    module.hot.accept("./AIOverview.vue?vue&type=template&id=730c64a6&scoped=true", function () {
      api.rerender('730c64a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/AIOverview.vue"
export default component.exports